"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Svg_1 = __importDefault(require("../Svg"));

var CreditCard = function CreditCard(_a) {
  var fill = _a.fill,
      props = __rest(_a, ["fill"]);

  return react_1.default.createElement(Svg_1.default, __assign({}, props, {
    viewBox: "0 0 30.571 19"
  }), react_1.default.createElement("g", {
    transform: "translate(-300.714 -1.929)"
  }, react_1.default.createElement("rect", {
    fill: "#0a5296",
    width: "19.692",
    height: "16",
    rx: "8",
    transform: "translate(300.714 1.929)"
  }), react_1.default.createElement("path", {
    fill: "#fff",
    d: "M309.237,3.533a6.487,6.487,0,1,0,6.487,6.487A6.488,6.488,0,0,0,309.237,3.533Zm-4.605,6.487a4.4,4.4,0,0,1,3.385-4.365v8.73A4.4,4.4,0,0,1,304.632,10.02Zm5.436,4.365V5.655a4.4,4.4,0,0,1,3.384,4.365A4.4,4.4,0,0,1,310.068,14.386Z",
    transform: "translate(-0.087 -0.069)"
  })));
};

CreditCard.displayName = 'CreditCard';
exports.default = CreditCard;